import React from 'react'
import { WHITE } from '@omnilert/components'

const Send = () => {
  return (
    <svg
      fill='none'
      height='20'
      viewBox='0 0 26 26'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.806 13.631a.939.939 0 01.067-1.642L22.585 1.385l-5.01 20.504a.95.95 0 01-.574.656.98.98 0 01-.878-.076L1.806 13.632z'
        stroke={WHITE}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M11.49 19.61l-2.865 2.867a.474.474 0 01-.809-.335v-4.8l14.77-15.957'
        stroke={WHITE}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  )
}

export default Send
